__turbopack_context__.v({
  "container": "Tag-module__2NvMPW__container",
});
